import React from 'react'

export const Love = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.25" y="1.25" width="27.5" height="27.5" rx="13.75" fill="white" />
    <rect x="4.5" y="4.5" width="21" height="21" rx="10.5" fill="black" />
    <path
      d="M14.9998 20.625L14.7361 20.4492C13.4828 19.6122 11.897 18.6662 10.7225 17.2758C9.48466 15.8109 8.89081 14.3065 8.90605 12.6762C8.9245 10.8557 10.3844 9.375 12.1603 9.375C13.5698 9.375 14.507 10.1953 14.9998 10.7874C15.4926 10.1953 16.4298 9.375 17.8393 9.375C19.6152 9.375 21.0751 10.8557 21.0935 12.6753C21.11 14.3065 20.5161 15.8101 19.2771 17.2749C18.1026 18.6662 16.5168 19.6122 15.2635 20.4492L14.9998 20.625Z"
      fill="white"
    />
    <rect x="1.25" y="1.25" width="27.5" height="27.5" rx="13.75" stroke="black" strokeWidth="1.5" />
  </svg>
)
